"use client";

import type { ReactNode } from "react";
import React, { createContext, useContext, useMemo } from "react";

import type { ThirdPartiesPageDTO } from "@repo/ui/types/cms/third-parties.dto";

interface ThirdPartiesContextType {
  data: ThirdPartiesPageDTO | null;
}

const ThirdPartiesContext = createContext<ThirdPartiesContextType | undefined>(undefined);

export function ThirdPartiesProvider({
  children,
  data,
}: Readonly<{
  children: ReactNode;
  data: ThirdPartiesPageDTO | null;
}>): React.JSX.Element {
  const value = useMemo(() => ({ data }), [data]);
  return <ThirdPartiesContext.Provider value={value}>{children}</ThirdPartiesContext.Provider>;
}

export function useThirdParties() {
  const context = useContext(ThirdPartiesContext);
  if (!context) {
    throw new Error("useThirdParties must be used within ThirdPartiesProvider");
  }
  return context;
}
